require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_core-js@2.5.1@core-js/library/fn/object/get-prototype-of.js
// module id = 524
// module chunks = 0 1